import Icon, {
  DeleteOutlined,
  DownOutlined,
  EditTwoTone,
  HistoryOutlined,
  ImportOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
  SendOutlined,
  SettingOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Dropdown, Menu, Modal, notification, Popover, Table, Tag, Tooltip } from 'antd';
import { selectFormatDate } from 'app/commonRedux/appSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import IconAdd from 'assets/icons/ic_add_gray.svg';
import IconExport from 'assets/icons/ic_export_gray.svg';
import EmployeeColumn from 'components/EmployeeColumn';
import ITVSearch from 'components/ITVSearch';
import ITVTable from 'components/ITVTable';
import MenuAction from 'components/MenuAction';
import { getCategoryWithType } from 'features/configuration/categoryAction';
import { getDepartmentList, selectDepartment } from 'features/department/departmentSlice';
import SearchPopup from 'features/employee/components/SearchPopup';
import { selectEmployee, setCheckRow } from 'features/employee/employeeSlice';
import { HeaderRemove } from 'features/masterData/Department/styled';
import {
  exportPayrollDetailExcel,
  exportPayrollDetailPdf,
  getPayrollGroupUser,
  getPayrollUserStatuses,
  importPayrollCsv,
  sendActionPayroll,
  sendPayslipManual,
  syncPayroll,
  updatePayroll,
} from 'features/payroll/payrollAction';
import { selectPayroll } from 'features/payroll/payrollSlice';
import ModalFormReason from 'features/timesheet/components/ModalFormReason';
import { PermissionType, TaxProfiles } from 'hrm-common/extensions/enums/personel';
import { selectPermissions, selectUser as selectAuthUser } from 'features/auth/authSlice';
import moment from 'moment';
import numeral from 'numeral';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import styled, { css } from 'styled-components';
import CustomButton from 'styles/buttonStyled';
import { TitleColumnCenter } from 'styles/tableStyled';
import { getUser } from 'utils/auth';
import { capitalizeFirstLetter, removeAccents } from 'utils/text';
import ViewPayslip from '../ViewPayroll/components/ViewPayslip';
import HistoryRequest from './HistoryRequest';
import ViewEdit from './ViewEdit';
import AddColumn from './components/AddColumn';
import ViewAddMember from './components/ViewAddMember';
import { checkPermissionCurrentUser, getActionCurrentUser } from './functionForWorkFlow';
import HeaderTop from './components/HeaderUp';
import HeaderDown from './components/HeaderDown';
import MaskedValueRenderer from 'components/MaskedValueRenderer';
import ImportPayrollResultModal, { ImportResult } from './components/ImportPayrollResultModal';
import ApprovalProgress from './components/ApprovalProgress';
import PayrollSummaryCards, { PayrollSummaryTotals } from './components/PayrollSummaryCards';
import { buildSummaryRow } from './components/buildSummaryRow';
import payrollApi from 'api/payrollApi';
import dayjs from 'dayjs';

enum MODE {
  VIEW = 'VIEW',
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  VIEW_HISTORY = 'VIEW_HISTORY',
}
enum TypeEditPayroll {
  TITLE = 'title',
  USER = 'user',
}
const filterDefault = {
  sortBy: 'status',
  orderBy: 'asc',
};

const ManageRequestTab = (props: any) => {
  // ...

  const IconExportComponents = (
    <CustomIcon type={'export'} component={() => <img src={IconExport} alt="" />} />
  );
  const { id }: any = useParams();
  const {
    showData,
    sizePage,
    setSizePage,
    currentPage,
    setCurrentPage,
    setSort,
    setSortBy,
    setSearch,
    callApi,
  } = props;
  const dispatch = useAppDispatch();
  const historyRouter = useHistory();
  const userPermissions = useAppSelector(selectPermissions) || [];
  const currentUser: any = useAppSelector(selectAuthUser);
  const canOpenPayrollSettings =
    currentUser?.isSystemAdmin || userPermissions.includes(PermissionType.SETUP_PAYROLL);
  const { t } = useTranslation([
    'timesheet',
    'action',
    'status',
    'employee',
    'dashboard',
    'payroll',
    'recruitment',
  ]);
  const [data, setData] = useState([]); //dataMock.payroll
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [resultModalVisible, setResultModalVisible] = useState(false);
  const [importResult, setImportResult] = useState<ImportResult | null>(null);
  const [mode, setMode] = useState<string>('');
  const [currentItem, setCurrentItem] = useState<any>(null);
  const [isVisibleAddColumn, setIsVisibleAddColumn] = useState(false);
  const [, setWidthTable] = useState(550);
  const childRefAddColumn = useRef<any>();
  const payrollGroupUser = useAppSelector(selectPayroll)?.payrollGroupUser;
  const loadingPayrollGroupUser = useAppSelector(selectPayroll)?.loadingPayrollGroupUser;
  const [summary, setSummary] = useState<{
    totals: PayrollSummaryTotals;
    summaryRecord: any;
  } | null>(null);
  const [loadingSummary, setLoadingSummary] = useState(false);
  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoadingSummary(true);
    payrollApi
      .getPayrollSummary(id)
      .then((res: any) => !cancelled && setSummary(res?.data || null))
      .catch(() => !cancelled && setSummary(null))
      .finally(() => !cancelled && setLoadingSummary(false));
    return () => {
      cancelled = true;
    };
  }, [id, payrollGroupUser]);
  const dateFormat = useAppSelector(selectFormatDate);
  // const currencyFormat = useAppSelector(selectCurrencyFormat);
  const [selectUser, setSelectUser] = useState<any>([]);
  const dataEmployee: any = useAppSelector(selectEmployee);
  const selectRowKey = dataEmployee?.selectRowKey;
  const [showModal, setShowModal] = useState(false);
  const [allowanceColAdd, setAllowanceColAdd] = useState({
    grossTax: false,
    grossNoTax: false,
    noGrossTax: false,
    noGrossNoTax: false,
  });
  const [bonusColAdd, setBonusColAdd] = useState({
    tax: false,
    noTax: false,
  });
  const [workflowType, setupWorkflowType] = useState<any>(null);
  const [currentWorkflowStatus, setCurrentWorkflowStatus] = useState<any>(null);
  const [currentActionId, setCurrentActionId] = useState<any>(null);
  // Lý do chỉ bắt buộc khi action hiện tại là từ chối/trả lại
  const [currentActionIsReject, setCurrentActionIsReject] = useState(false);
  const [selectUserPayRollId, setSelectUserPayRollId] = useState<any>([]);
  // Map userId -> trạng thái duyệt của từng nhân viên (case-by-case)
  const [userStatusMap, setUserStatusMap] = useState<Record<string, string>>({});
  // Ref để cột status (bị đóng băng trong `columns` state) luôn đọc được map mới nhất
  const userStatusMapRef = useRef<Record<string, string>>({});
  // Map mã trạng thái (statusName) -> tên bước (node.data.label) trong workflow, để hiển thị "đang ở bước nào"
  const stepLabelByStatusRef = useRef<Record<string, string>>({});
  const departments = useAppSelector(selectDepartment).data;
  const [, setIsFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const colEmployeeTableRoot = [
    {
      label: t('payroll:salary'),
      value: 'salary',
    },
    {
      label: t('payroll:timesheet'),
      value: 'timesheet',
    },
    {
      label: t('payroll:allowance'),
      value: 'allowance',
    },
    {
      label: t('payroll:businessSalary'),
      value: 'businessSalary',
    },
    {
      label: t('payroll:salaryThisPeriod'),
      value: 'salaryThisPeriod',
    },
    {
      label: t('payroll:bonus'),
      value: 'bonus',
    },
    {
      label: t('payroll:adjustment'),
      value: 'adjust',
    },
    {
      label: t('payroll:overtime'),
      value: 'overtime',
    },
    {
      label: t('payroll:totalIncomeThisPeriod'),
      value: 'totalIncomeThisPeriod',
    },
    {
      label: t('payroll:no_of_dependents'),
      value: 'dependents',
    },
    {
      label: t('payroll:pitDeduction'),
      value: 'pitDeduction',
    },
    {
      label: t('payroll:taxableIncome'),
      value: 'taxableIncome',
    },
    {
      label: t('payroll:taxedIncome'),
      value: 'taxedIncome',
    },
    {
      label: 'PIT',
      value: 'pit',
    },
    {
      label: t('payroll:insurance'),
      value: 'insurance',
    },
    {
      label: t('payroll:advance'),
      value: 'advance',
    },
    {
      label: t('payroll:actual_take_home'),
      value: 'actual',
    },
    {
      label: t('payroll:total_cost'),
      value: 'total',
    },
  ];

  const [addColumnTableHeader, setAddColumnTableHeader] = useState(colEmployeeTableRoot);

  useEffect(() => {
    // Get dataset department
    dispatch(
      getDepartmentList({
        filters: filterDefault,
      }),
    );
    // Get dataset position
    dispatch(
      getCategoryWithType({
        typeConfig: 'position',
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!showModal) return;

    setSelectUser(
      selectRowKey?.filter(
        (item: any) => !selectUserPayRollId?.some((value: any) => value === item),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRowKey, showModal]);

  const fetchUserStatuses = () => {
    if (!id) return;
    dispatch<any>(getPayrollUserStatuses({ id: Number(id) })).then((res: any) => {
      const list = res?.payload?.data || [];
      const map: Record<string, string> = {};
      list.forEach((item: any) => {
        if (item?.userId) map[String(item.userId)] = item?.status;
      });
      userStatusMapRef.current = map;
      setUserStatusMap(map);
    });
  };

  const callAPiGetUserGroup = () => {
    callApi && callApi();
    fetchUserStatuses();
  };

  useEffect(() => {
    fetchUserStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const formatDataIncludeUserIds = (data: any) => {
    return data?.map((item: any) => ({ ...item, id: item?.user?.id }));
  };
  useEffect(() => {
    if (payrollGroupUser) {
      setColumns(COLUMNS);
      const formattedPayroll = formatDataIncludeUserIds(payrollGroupUser?.payroll);
      setData(formattedPayroll);
      setFilteredData(formattedPayroll);
      setSelectUserPayRollId(
        (prevSelectedUserIds: any[]) =>
          prevSelectedUserIds?.filter((userId: any) =>
            formattedPayroll?.some((record: any) => record?.user?.id === userId),
          ) || [],
      );
      setupWorkflowType(payrollGroupUser?.workflowType);
      // Dựng map statusName -> tên bước (label) từ các node của workflow
      const stepMap: Record<string, string> = {};
      (payrollGroupUser?.workflowType?.nodes || []).forEach((n: any) => {
        const st = n?.data?.statusName;
        const label = n?.data?.label;
        if (st && label) stepMap[String(st)] = label;
      });
      stepLabelByStatusRef.current = stepMap;
      setCurrentWorkflowStatus(payrollGroupUser?.payrollDetails?.status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payrollGroupUser]);

  // Update currentItem when data changes to keep it realtime
  useEffect(() => {
    if (currentItem && data.length > 0) {
      const updatedCurrentItem = data.find((item: any) => item?.user?.id === currentItem?.user?.id);
      if (updatedCurrentItem) {
        setCurrentItem(updatedCurrentItem);
      }
    }
  }, [data, currentItem?.user?.id]);

  useEffect(() => {
    const enrichAdvanceData = async () => {
      if (!payrollGroupUser?.payroll) {
        return;
      }

      const userIds = payrollGroupUser.payroll.map((r: any) => r?.user?.id).filter(Boolean);
      const months = payrollGroupUser.payroll.map((r: any) =>
        dayjs(r?.monthYear).format('MM/YYYY'),
      );

      try {
        const res = await payrollApi.getTotalAdvance({
          userIds,
          months,
        });

        const resultList = Array.isArray(res?.data?.result)
          ? res.data.result
          : Array.isArray(res)
          ? res
          : [];

        const advanceMap = new Map<string, number>();

        (resultList || []).forEach((item: any) => {
          advanceMap.set(String(item.userId).trim(), item.totalAdvance);
        });

        const enriched = payrollGroupUser.payroll.map((record: any) => {
          const userId = String(record?.user?.id).trim();

          const totalAdvance = advanceMap.get(userId) ?? 0;

          return {
            ...record,
            dataPayroll: {
              ...(record.dataPayroll || {}),
              totalAdvance,
            },
          };
        });

        const formattedEnriched = formatDataIncludeUserIds(enriched);
        setData(formattedEnriched);
        setFilteredData(formattedEnriched);
      } catch (error) {
        console.error('❌ Error fetching total advance:', error);
      }
    };

    enrichAdvanceData();
  }, [payrollGroupUser]);

  //  Listen for advance update events
  useEffect(() => {
    const handleAdvanceUpdated = async (event: any) => {
      //  Re-fetch advance data for the specific user
      if (payrollGroupUser?.payroll) {
        const userIds = payrollGroupUser.payroll.map((r: any) => r?.user?.id).filter(Boolean);
        const months = payrollGroupUser.payroll.map((r: any) =>
          dayjs(r?.monthYear).format('MM/YYYY'),
        );

        try {
          const res = await payrollApi.getTotalAdvance({
            userIds,
            months,
          });

          const resultList = Array.isArray(res?.data?.result)
            ? res.data.result
            : Array.isArray(res)
            ? res
            : [];

          const advanceMap = new Map<string, number>();
          (resultList || []).forEach((item: any) => {
            advanceMap.set(String(item.userId).trim(), item.totalAdvance);
          });

          const enriched = payrollGroupUser.payroll.map((record: any) => {
            const userId = String(record?.user?.id).trim();
            const totalAdvance = advanceMap.get(userId) ?? 0;
            return {
              ...record,
              dataPayroll: {
                ...(record.dataPayroll || {}),
                totalAdvance,
              },
            };
          });

          const formattedEnriched = formatDataIncludeUserIds(enriched);
          setData(formattedEnriched);
          setFilteredData(formattedEnriched);
          console.log('🎯 Advance data refreshed successfully');
        } catch (error) {
          console.error('❌ Error refreshing advance data:', error);
        }
      }
    };

    window.addEventListener('advanceUpdated', handleAdvanceUpdated);

    return () => {
      window.removeEventListener('advanceUpdated', handleAdvanceUpdated);
    };
  }, [payrollGroupUser]);

  const handleHideAddColumn = () => {
    setIsVisibleAddColumn(false);
  };
  const handleVisibleChange = (visible: any) => {
    setIsVisibleAddColumn(visible);
  };

  const MENU = [
    {
      name: t('timesheet:View_Detail'),
      icon: <EditTwoTone twoToneColor="#F1592A" />,
      checkDisabled: () =>
        !checkPermissionCurrentUser(workflowType, 'view', currentWorkflowStatus, getUser()?.id),
      handleClick: (value: any) => {
        setCurrentItem(value);
        setMode(MODE.UPDATE);
      },
    },
    {
      name: t('action:delete'),
      type: 'delete',
      icon: <DeleteOutlined />,
      checkDisabled: () =>
        !checkPermissionCurrentUser(workflowType, 'delete', currentWorkflowStatus, getUser()?.id),
      handleClick: (item: any) => {
        const currentData = payrollGroupUser?.payroll
          ?.map((item: any) => item?.user)
          ?.filter((i: any) => i?.id === item?.user?.id)
          ?.map((item: any) => item?.id);
        const body = {
          userIds: [...currentData],
          type: TypeEditPayroll.USER,
        };
        dispatch(
          updatePayroll({
            id,
            actionType: 'delete',
            body,
            callBack: () => {
              callAPiGetUserGroup();
              setShowModal(false);
              dispatch(setCheckRow([]));
            },
          }),
        );
      },
    },
  ];

  // Nhận diện action từ chối/trả lại theo nhãn (đồng bộ với isRejectAction ở backend)
  const isRejectLabel = (label: any) => {
    const text = String(label || '').toLowerCase();
    const keywords = [
      'reject',
      'decline',
      'deny',
      'return',
      'cancel',
      'back',
      'từ chối',
      'tu choi',
      'trả lại',
      'tra lai',
      'trả về',
      'tra ve',
      'hủy',
      'huy',
      'gửi lại',
      'gui lai',
      'không duyệt',
      'khong duyet',
    ];
    return keywords.some((k) => text.includes(k));
  };

  const handleClickAction = (actionId: any, label?: any) => {
    setRejectModalVisible(true);
    setCurrentActionId(actionId);
    setCurrentActionIsReject(isRejectLabel(label));
  };

  // Trạng thái dùng để tính action khả dụng:
  // - Nếu cả đợt đã close -> trạng thái hiệu lực luôn là close.
  // - Nếu có chọn nhân viên và các NV đó CÙNG 1 trạng thái per-user -> dùng trạng thái đó
  //   (cho phép xử lý riêng cả NV đang "held" ở bước trước).
  // - Ngược lại -> dùng trạng thái của cả đợt (group).
  const getEffectiveStatus = () => {
    if (currentWorkflowStatus === 'close') return 'close';
    if (selectUserPayRollId?.length) {
      const statuses = selectUserPayRollId
        .map((uid: any) => userStatusMap?.[String(uid)])
        .filter(Boolean);
      const uniq = Array.from(new Set(statuses));
      if (uniq.length === 1) return uniq[0];
    }
    return currentWorkflowStatus;
  };
  const effectiveStatus = getEffectiveStatus();

  // Gửi payslip: khi đợt lương đã close thì toàn bộ nhân viên được tính là 'close'.
  // Khi chưa close đợt thì kiểm tra per-user theo từng NV.
  const statusOfUser = (uid: any) => {
    if (currentWorkflowStatus === 'close') return 'close';
    return userStatusMap?.[String(uid)] || currentWorkflowStatus;
  };
  const anyUserClosed =
    currentWorkflowStatus === 'close' ||
    Object.values(userStatusMap || {}).some((s) => s === 'close');
  const selectedAllClosed =
    !!selectUserPayRollId?.length &&
    selectUserPayRollId.every((uid: any) => statusOfUser(uid) === 'close');

  const menu = (
    <Menu>
      {getActionCurrentUser(workflowType, effectiveStatus, getUser()?.id)?.map(
        (item: any, index: any) => {
          return (
            <Menu.Item key={index} onClick={() => handleClickAction(item?.actionId, item?.label)}>
              {item?.label}
            </Menu.Item>
          );
        },
      )}
    </Menu>
  );

  // Danh sách filter theo trạng thái duyệt (các step của workflow + tất cả các giá trị thực tế hiển thị ở cột).
  const statusFilterOptions = useMemo(() => {
    const seen = new Set<string>();
    const opts: { text: string; value: string }[] = [];

    // Temporary map to look up step labels from status names
    const stepLabelMap: Record<string, string> = {};
    (payrollGroupUser?.workflowType?.nodes || workflowType?.nodes || []).forEach((n: any) => {
      const st = n?.data?.statusName;
      const label = n?.data?.label;
      if (st && label) {
        stepLabelMap[String(st)] = label;
      }
    });

    // 1. Add options from workflow nodes (steps)
    (payrollGroupUser?.workflowType?.nodes || workflowType?.nodes || []).forEach((n: any) => {
      const st = n?.data?.statusName;
      if (st && !seen.has(String(st))) {
        seen.add(String(st));
        opts.push({ text: n?.data?.label || st, value: String(st) });
      }
    });

    // 2. Add other unique status values from the actual data records (e.g. 'close', 'draft', etc.)
    (data || []).forEach((record: any) => {
      const st =
        userStatusMapRef.current?.[String(record?.user?.id)] ||
        userStatusMap?.[String(record?.user?.id)] ||
        currentWorkflowStatus ||
        '';
      if (st && !seen.has(String(st))) {
        seen.add(String(st));
        const stepLabel = stepLabelMap[String(st)];
        const capitalize = (s: any) =>
          typeof s === 'string' && s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
        opts.push({ text: capitalize(stepLabel || st), value: String(st) });
      }
    });

    // 3. Fallback: Add currentWorkflowStatus if not already captured
    if (currentWorkflowStatus && !seen.has(String(currentWorkflowStatus))) {
      seen.add(String(currentWorkflowStatus));
      const stepLabel = stepLabelMap[String(currentWorkflowStatus)];
      const capitalize = (s: any) =>
        typeof s === 'string' && s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
      opts.push({
        text: capitalize(stepLabel || currentWorkflowStatus),
        value: String(currentWorkflowStatus),
      });
    }

    return opts;
  }, [
    payrollGroupUser?.workflowType?.nodes,
    workflowType?.nodes,
    data,
    userStatusMap,
    currentWorkflowStatus,
  ]);

  const COLUMNS: any = [
    {
      title: t('employee:employee_information_fields.id'),
      dataIndex: 'employeeId',
      key: 'employeeId',
      width: 100,
      minWidth: 100,
      align: 'center',
      fixed: 'left',
      sorter: {
        compare: (a: any, b: any) => {
          if (a.user?.employeeId && b.user?.employeeId)
            return a.user?.employeeId.localeCompare(b.user?.employeeId);
          return 0;
        },
        multiple: 3,
      },
      render: function (text: any, record: any, index: any) {
        return record?.user?.employeeId;
      },
    },
    {
      title: t('employee:employee_information_fields.employee'),
      dataIndex: 'employee',
      key: 'employee',
      width: 230,
      minWidth: 230,
      ellipsis: true,
      fixed: 'left',
      render: function (text: any, record: any, index: any) {
        const isPostTermination = record?.dataPayroll?.formulaProfile === 'POST_TERMINATION';
        return (
          <div>
            <EmployeeColumn
              avatar={record?.user?.fullName}
              fullName={record?.user?.fullName}
              email={record?.user?.email}
            />
            {isPostTermination && (
              <div style={{ marginTop: 4 }}>
                <Tooltip
                  title={
                    t('payroll:post_termination_badge_tooltip') ||
                    'Nhân sự thôi việc trước ngày chi trả. Khấu trừ thuế TNCN 10% (NĐ 253/2026/NĐ-CP) cho thu nhập >= 5.000.000đ, không giảm trừ gia cảnh.'
                  }
                >
                  <Tag
                    color="orange"
                    style={{
                      fontSize: 11,
                      lineHeight: '18px',
                      padding: '0 6px',
                      borderRadius: 4,
                      fontWeight: 500,
                    }}
                  >
                    {t('payroll:post_termination_badge_label') || 'Sau thôi việc (NĐ 253)'}
                  </Tag>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: t('employee:employee_information_fields.line'),
      dataIndex: 'projectPrimaryName',
      align: 'left',
      key: 'projectPrimaryName',
      width: 200,
      minWidth: 200,
      render: function (text: any, record: any, index: any) {
        return record?.user?.projectPrimaryName || '';
      },
    },
    {
      title: t('employee:employee_information_fields.position'),
      dataIndex: 'position',
      align: 'left',
      key: 'position',
      width: 100,
      minWidth: 100,
      ellipsis: true,
      render: function (text: any, record: any, index: any) {
        return record?.user?.positionName || '';
      },
    },
    {
      title: <HeaderDown>{t('dashboard:contract.contract_type')}</HeaderDown>,
      dataIndex: 'contract',
      align: 'left',
      key: 'contract',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        const value = record?.dataPayroll?.dataPayroll?.salary?.name || '';
        switch (value) {
          case TaxProfiles.MORE_THAN_THREE_MONTH:
            return t('employee:contract_information_fields.more_than_month');
          case TaxProfiles.LESS_THAN_THREE_MONTH:
            return t('employee:contract_information_fields.less_than_month');
          case TaxProfiles.INTERN:
            return t('employee:contract_information_fields.intern');
          case TaxProfiles.PROBATION:
            return t('employee:contract_information_fields.probation');
          default:
            return '';
        }
      },
    },
    {
      title: t('employee:salary_information_fields.col_start_date'),
      dataIndex: 'startDate',
      align: 'left',
      key: 'startDate',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        const value = record?.user?.contractStartDate;
        return value ? moment(value)?.format(dateFormat) : '';
      },
    },
    {
      title: t('employee:salary_information_fields.col_end_date'),
      dataIndex: 'endDate',
      align: 'left',
      key: 'endDate',
      width: 100,
      minWidth: 100,
      render: function (text: any, record: any, index: any) {
        const value = record?.user?.endDate;
        return value ? moment(value)?.format(dateFormat) : '';
      },
    },
    {
      title: t('payroll:approval_status', 'Approval status'),
      dataIndex: 'approvalStatus',
      align: 'center',
      key: 'approvalStatus',
      width: 160,
      minWidth: 160,
      // Filter theo step: lọc về 1 trạng thái rồi "check all" chỉ chọn đúng NV ở step đó
      filters: statusFilterOptions,
      onFilter: (value: any, record: any) => {
        const st =
          currentWorkflowStatus === 'close'
            ? 'close'
            : userStatusMapRef.current?.[String(record?.user?.id)] || currentWorkflowStatus || '';
        return String(st) === String(value);
      },
      render: function (text: any, record: any, index: any) {
        // Trạng thái duyệt theo từng NV (case-by-case); fallback về status cụm.
        // Đọc từ ref để tránh closure cũ khi columns đã được lưu vào state.
        const st =
          currentWorkflowStatus === 'close'
            ? 'close'
            : userStatusMapRef.current?.[String(record?.user?.id)] ||
              userStatusMap?.[String(record?.user?.id)] ||
              currentWorkflowStatus ||
              '';
        if (!st) return '';
        // Tên bước trong workflow (VD "Manager Review"); nếu không map được thì hiện mã trạng thái
        const stepLabel = stepLabelByStatusRef.current?.[String(st)];
        const capitalize = (s: any) =>
          typeof s === 'string' && s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
        const mainText = capitalize(stepLabel || st);
        return (
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontWeight: 500 }}>{mainText}</div>
            {stepLabel ? (
              <div style={{ fontSize: 11, color: 'var(--cl_gray400, #98A2B3)' }}>{st}</div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <TitleColumnCenter>{t('employee:employee_information_fields.action')}</TitleColumnCenter>
        );
      },
      dataIndex: 'action',
      key: 'action',
      width: 60,
      minWidth: 60,
      align: 'center',
      fixed: 'right',
      render: (status: any, record: any, index: any) => {
        return <MenuAction menu={MENU} data={record} />;
      },
    },
  ];
  const [columns, setColumns] = useState(COLUMNS);

  const removeDuplicates = (arr: Array<string>) => {
    const uniq = new Set(arr.map((e) => JSON.stringify(e)));
    const res = Array.from(uniq).map((e) => JSON.parse(e));
    return res;
  };

  const columnSource = summary?.summaryRecord ? [...(data || []), summary.summaryRecord] : data;

  const getAllAllowance = () => {
    const dataAllowances = columnSource
      ?.map((item: any) => item?.dataPayroll?.dataPayroll?.salary?.allowances)
      ?.filter((item: any) => item) //remove undefined
      ?.flat(1);
    //?.map((item) => item.name); //get all string name
    const newDataAllowances = removeDuplicates(dataAllowances);
    const uniqueAllowances = newDataAllowances.reduce((acc: any[], current: any) => {
      const x = acc.find((item) => item.name === current.name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    return uniqueAllowances;
  };

  const getAllOtRate = () => {
    const dataOtRate = columnSource
      ?.map((item: any) => item?.dataPayroll?.dataPayroll?.overtime)
      ?.filter((item: any) => item) //remove undefined
      ?.flat(1)
      ?.map((item) => item.rate); //get all string name
    return removeDuplicates(dataOtRate);
  };

  const getAllBonus = () => {
    const dataBonus = columnSource
      ?.map((item: any) => item?.dataPayroll?.dataPayroll?.bonus)
      ?.filter((item: any) => item) //remove undefined
      ?.flat(1);
    //?.map((item) => item.name); //get all string name
    return removeDuplicates(dataBonus);
  };

  const addColumns = (cols: any) => {
    const dataIndexs = columns.map((item: any) => item.dataIndex);
    const arr = COLUMNS.filter((item: any) => dataIndexs.includes(item.dataIndex));

    const dataAllowances = getAllAllowance();
    const dataAllowancesGross = dataAllowances.filter((item: any) => item?.isGross);
    const dataAllowancesNoGross = dataAllowances.filter((item: any) => !item?.isGross);

    const dataOtRate = getAllOtRate()?.sort();

    const dataBonus = getAllBonus();

    // eslint-disable-next-line array-callback-return
    const temp = cols.map((item: any) => {
      if (item.value === 'salary') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          children: [
            {
              title: <HeaderTop>{t('payroll:gross')}</HeaderTop>,
              dataIndex: 'gross',
              key: 'gross',
              align: 'right',
              ellipsis: true,
              width: 100,
              minWidth: 100,
              render: function (salary: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.salary?.grossSalary || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
            {
              title: <HeaderTop>{t('payroll:main')}</HeaderTop>,
              dataIndex: 'main',
              key: 'main',
              align: 'right',
              ellipsis: true,
              width: 100,
              minWidth: 100,
              render: function (salary: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.salary?.mainSalary || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
          ],
        };
      }
      if (item.value === 'timesheet') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          children: [
            {
              title: <HeaderTop margin={-16}>{t('payroll:standard_hours')}</HeaderTop>,
              dataIndex: 'paidHours',
              key: 'paidHours',
              align: 'right',
              ellipsis: false,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.timeSheet?.standardHours;
                return value || 0;
              },
            },
            {
              title: <HeaderTop margin={-16}>{t('payroll:leave_off_hours')}</HeaderTop>,
              dataIndex: 'paidLeave',
              key: 'paidLeave',
              align: 'right',
              ellipsis: false,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.timeSheet?.leaveOffHours;
                return value ? Number(value).toFixed(2) : 0;
              },
            },
            {
              title: <HeaderTop>{t('payroll:actual_hours')}</HeaderTop>,
              dataIndex: 'actual',
              key: 'actual',
              align: 'right',
              ellipsis: false,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.timeSheet?.actualHours;
                return value || 0;
              },
            },
            {
              title: <HeaderTop>{t('payroll:holiday_hours')}</HeaderTop>,
              dataIndex: 'holidayHours',
              key: 'holidayHours',
              align: 'right',
              ellipsis: false,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.timeSheet?.holidayHours;
                return value || 0;
              },
            },
            {
              title: <HeaderTop margin={-16}>{t('payroll:total_paid_hours')}</HeaderTop>,
              dataIndex: 'actual',
              key: 'actual',
              align: 'right',
              ellipsis: false,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.timeSheet?.totalPaidHours;
                return value || 0;
              },
            },
          ],
        };
      }
      if (item.value === 'allowance') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          children: [
            {
              title: (
                <div>
                  <div>{t('payroll:gross')}</div>
                  {/* <div>{`(${dataAllowancesGross?.map((x) => x?.name).join(', ')})`}</div> */}
                </div>
              ),
              dataIndex: 'gross',
              key: 'gross',
              children: [
                {
                  title: () => (
                    <div>
                      {t('payroll:tax')}{' '}
                      {allowanceColAdd?.grossTax ? (
                        <MinusCircleOutlined
                          style={{ color: '#f1592a' }}
                          onClick={() => handleCloseColumn('grossTax', item.value)}
                        />
                      ) : (
                        <PlusCircleOutlined
                          style={{ color: '#3b82f6' }}
                          onClick={() => handleAddColumn('grossTax', item.value)}
                        />
                      )}
                    </div>
                  ),
                  dataIndex: 'tax',
                  key: 'tax',
                  width: 130,
                  minWidth: 100,
                  align: 'right',
                  children: allowanceColAdd?.grossTax
                    ? [
                        ...dataAllowancesGross
                          .filter((item: any) => item?.isTaxed)
                          ?.map((item: any) => ({
                            title: capitalizeFirstLetter(item?.name),
                            dataIndex: item?.name,
                            key: item?.name,
                            align: 'right',
                            ellipsis: true,
                            width: 130,
                            minWidth: 100,
                            render: function (text: any, record: any, index: any) {
                              const value =
                                record?.dataPayroll?.dataPayroll?.salary?.allowances?.find(
                                  (i: any) => i?.name === item?.name,
                                )?.money || 0;
                              //salary marketing
                              return <MaskedValueRenderer value={value} />;
                            },
                          })),
                        {
                          title: t('payroll:total'),
                          dataIndex: 'total',
                          key: 'total',
                          align: 'right',
                          ellipsis: true,
                          width: 130,
                          minWidth: 100,
                          render: function (text: any, record: any, index: any) {
                            const value =
                              record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                                (prev: any, i: any) =>
                                  i?.isGross && i?.isTaxed ? prev + i?.money : prev + 0,
                                0,
                              ) || 0;
                            return <MaskedValueRenderer value={value} />;
                          },
                        },
                      ]
                    : [],
                  render: function (text: any, record: any, index: any) {
                    const value =
                      record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                        (prev: any, i: any) =>
                          i?.isGross && i?.isTaxed ? prev + i?.money : prev + 0,
                        0,
                      ) || 0;
                    return <MaskedValueRenderer value={value} />;
                  },
                },
                {
                  title: () => (
                    <div>
                      {t('payroll:no_tax')}{' '}
                      {allowanceColAdd?.grossNoTax ? (
                        <MinusCircleOutlined
                          style={{ color: '#f1592a' }}
                          onClick={() => handleCloseColumn('grossNoTax', item.value)}
                        />
                      ) : (
                        <PlusCircleOutlined
                          style={{ color: '#3b82f6' }}
                          onClick={() => handleAddColumn('grossNoTax', item.value)}
                        />
                      )}
                    </div>
                  ),
                  dataIndex: 'noTax',
                  key: 'noTax',
                  width: 130,
                  minWidth: 100,
                  align: 'right',
                  children: allowanceColAdd?.grossNoTax
                    ? [
                        ...dataAllowancesGross
                          ?.filter((item: any) => !item?.isTaxed)
                          ?.map((item: any) => ({
                            title: capitalizeFirstLetter(item?.name),
                            dataIndex: item?.name,
                            key: item?.name,
                            align: 'right',
                            ellipsis: true,
                            width: 130,
                            minWidth: 100,
                            render: function (text: any, record: any, index: any) {
                              const value =
                                record?.dataPayroll?.dataPayroll?.salary?.allowances?.find(
                                  (i: any) => i?.name === item?.name,
                                )?.money || 0;
                              //salary marketing
                              return <MaskedValueRenderer value={value} />;
                            },
                          })),
                        {
                          title: t('payroll:total'),
                          dataIndex: 'total',
                          key: 'total',
                          align: 'right',
                          ellipsis: true,
                          width: 130,
                          minWidth: 100,
                          render: function (text: any, record: any, index: any) {
                            const value =
                              record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                                (prev: any, i: any) =>
                                  i?.isGross && !i?.isTaxed ? prev + i?.money : prev + 0,
                                0,
                              ) || 0;
                            return <MaskedValueRenderer value={value} />;
                          },
                        },
                      ]
                    : [],
                  render: function (text: any, record: any, index: any) {
                    const value =
                      record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                        (prev: any, i: any) =>
                          i?.isGross && !i?.isTaxed ? prev + i?.money : prev + 0,
                        0,
                      ) || 0;
                    return <MaskedValueRenderer value={value} />;
                  },
                },
              ],
            },
            {
              title: (
                <div>
                  <div>{t('payroll:no_gross')}</div>
                  {/* <div>{`(${dataAllowancesNoGross?.map((x) => x?.name).join(', ')})`}</div> */}
                </div>
              ),
              dataIndex: 'noGross',
              key: 'noGross',
              children: [
                {
                  title: () => (
                    <div>
                      {t('payroll:tax')}{' '}
                      {allowanceColAdd?.noGrossTax ? (
                        <MinusCircleOutlined
                          style={{ color: '#f1592a' }}
                          onClick={() => handleCloseColumn('noGrossTax', item.value)}
                        />
                      ) : (
                        <PlusCircleOutlined
                          style={{ color: '#3b82f6' }}
                          onClick={() => handleAddColumn('noGrossTax', item.value)}
                        />
                      )}
                    </div>
                  ),
                  dataIndex: 'tax',
                  key: 'tax',
                  width: 130,
                  minWidth: 100,
                  align: 'right',
                  children: allowanceColAdd?.noGrossTax
                    ? [
                        ...dataAllowancesNoGross
                          ?.filter((item: any) => item?.isTaxed)
                          ?.map((item: any) => ({
                            title: capitalizeFirstLetter(item?.name),
                            dataIndex: item?.name,
                            key: item?.name,
                            align: 'right',
                            ellipsis: true,
                            width: 130,
                            minWidth: 100,
                            render: function (text: any, record: any, index: any) {
                              const value =
                                record?.dataPayroll?.dataPayroll?.salary?.allowances?.find(
                                  (i: any) => i?.name === item?.name,
                                )?.money || 0;
                              return <MaskedValueRenderer value={value} />;
                            },
                          })),
                        {
                          title: t('payroll:total'),
                          dataIndex: 'total',
                          key: 'total',
                          align: 'right',
                          ellipsis: true,
                          width: 130,
                          minWidth: 100,
                          render: function (text: any, record: any, index: any) {
                            const value =
                              record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                                (prev: any, i: any) =>
                                  !i?.isGross && i?.isTaxed ? prev + i?.money : prev + 0,
                                0,
                              ) || 0;
                            return <MaskedValueRenderer value={value} />;
                          },
                        },
                      ]
                    : [],
                  render: function (text: any, record: any, index: any) {
                    const value =
                      record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                        (prev: any, i: any) =>
                          !i?.isGross && i?.isTaxed ? prev + i?.money : prev + 0,
                        0,
                      ) || 0;
                    return <MaskedValueRenderer value={value} />;
                  },
                },
                {
                  title: () => (
                    <div>
                      {t('payroll:no_tax')}{' '}
                      {allowanceColAdd?.noGrossNoTax ? (
                        <MinusCircleOutlined
                          style={{ color: '#f1592a' }}
                          onClick={() => handleCloseColumn('noGrossNoTax', item.value)}
                        />
                      ) : (
                        <PlusCircleOutlined
                          style={{ color: '#3b82f6' }}
                          onClick={() => handleAddColumn('noGrossNoTax', item.value)}
                        />
                      )}
                    </div>
                  ),
                  dataIndex: 'noTax',
                  key: 'noTax',
                  width: 130,
                  minWidth: 100,
                  align: 'right',
                  children: allowanceColAdd?.noGrossNoTax
                    ? [
                        ...dataAllowancesNoGross
                          ?.filter((item: any) => !item?.isTaxed)
                          ?.map((item: any) => ({
                            title: capitalizeFirstLetter(item?.name),
                            dataIndex: item?.name,
                            key: item?.name,
                            align: 'right',
                            ellipsis: true,
                            width: 130,
                            minWidth: 100,
                            render: function (text: any, record: any, index: any) {
                              const value =
                                record?.dataPayroll?.dataPayroll?.salary?.allowances?.find(
                                  (i: any) => i?.name === item?.name,
                                )?.money || 0;
                              return <MaskedValueRenderer value={value} />;
                            },
                          })),
                        {
                          title: t('payroll:total'),
                          dataIndex: 'total',
                          key: 'total',
                          align: 'right',
                          ellipsis: true,
                          width: 130,
                          minWidth: 100,
                          render: function (text: any, record: any, index: any) {
                            const value =
                              record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                                (prev: any, i: any) =>
                                  !i?.isGross && !i?.isTaxed ? prev + i?.money : prev + 0,
                                0,
                              ) || 0;
                            return <MaskedValueRenderer value={value} />;
                          },
                        },
                      ]
                    : [],
                  render: function (text: any, record: any, index: any) {
                    const value =
                      record?.dataPayroll?.dataPayroll?.salary?.allowances?.reduce(
                        (prev: any, i: any) =>
                          !i?.isGross && !i?.isTaxed ? prev + i?.money : prev + 0,
                        0,
                      ) || 0;
                    return <MaskedValueRenderer value={value} />;
                  },
                },
              ],
            },
          ],
        };
      }
      if (item.value === 'businessSalary') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.marketingSalary || 0;
            //salary marketing
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'salaryThisPeriod') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.salaryPeriodForActualWork || 0;
            return <StyledSalary>{<MaskedValueRenderer value={value} />}</StyledSalary>;
          },
        };
      }
      if (item.value === 'bonus') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 130,
          minWidth: 100,
          align: 'right',
          children: [
            {
              title: () => (
                <div style={{ marginTop: bonusColAdd?.tax ? 0 : -30 }}>
                  {t('payroll:tax')}{' '}
                  {bonusColAdd?.tax ? (
                    <MinusCircleOutlined
                      style={{ color: '#f1592a' }}
                      onClick={() => handleCloseColumn('tax', item.value)}
                    />
                  ) : (
                    <PlusCircleOutlined
                      style={{ color: '#3b82f6' }}
                      onClick={() => handleAddColumn('tax', item.value)}
                    />
                  )}
                </div>
              ),
              dataIndex: 'tax',
              key: 'tax',
              width: 100,
              minWidth: 100,
              align: 'right',
              children: bonusColAdd?.tax
                ? [
                    ...dataBonus
                      ?.filter((item: any) => item?.isTaxed)
                      ?.map((item: any) => ({
                        title: capitalizeFirstLetter(item?.name),
                        dataIndex: item?.name,
                        key: item?.name,
                        align: 'right',
                        ellipsis: true,
                        width: 100,
                        minWidth: 100,
                        render: function (text: any, record: any, index: any) {
                          const value =
                            record?.dataPayroll?.dataPayroll?.bonus?.find(
                              (i: any) => i?.name === item?.name,
                            )?.money || 0;
                          return <MaskedValueRenderer value={value} />;
                        },
                      })),
                    {
                      title: t('payroll:total'),
                      dataIndex: 'total',
                      key: 'total',
                      align: 'right',
                      ellipsis: true,
                      width: 100,
                      minWidth: 100,
                      render: function (text: any, record: any, index: any) {
                        const value =
                          record?.dataPayroll?.dataPayroll?.bonus?.reduce(
                            (prev: any, i: any) => (i?.isTaxed ? prev + i?.money : prev + 0),
                            0,
                          ) || 0;
                        return <MaskedValueRenderer value={value} />;
                      },
                    },
                  ]
                : [],
              render: function (text: any, record: any, index: any) {
                const value =
                  record?.dataPayroll?.dataPayroll?.bonus?.reduce(
                    (prev: any, i: any) => (i?.isTaxed ? prev + i?.money : prev + 0),
                    0,
                  ) || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
            {
              title: () => (
                <div style={{ marginTop: bonusColAdd?.noTax ? 0 : -30 }}>
                  {t('payroll:no_tax')}{' '}
                  {bonusColAdd?.noTax ? (
                    <MinusCircleOutlined
                      style={{ color: '#f1592a' }}
                      onClick={() => handleCloseColumn('noTax', item.value)}
                    />
                  ) : (
                    <PlusCircleOutlined
                      style={{ color: '#3b82f6' }}
                      onClick={() => handleAddColumn('noTax', item.value)}
                    />
                  )}
                </div>
              ),
              dataIndex: 'noTax',
              key: 'noTax',
              width: 100,
              minWidth: 100,
              align: 'right',
              children: bonusColAdd?.noTax
                ? [
                    ...dataBonus
                      ?.filter((item: any) => !item?.isTaxed)
                      ?.map((item: any) => ({
                        title: capitalizeFirstLetter(item?.name),
                        dataIndex: item?.name,
                        key: item?.name,
                        align: 'right',
                        ellipsis: true,
                        width: 100,
                        minWidth: 100,
                        render: function (text: any, record: any, index: any) {
                          const value =
                            record?.dataPayroll?.dataPayroll?.bonus?.find(
                              (i: any) => i?.name === item?.name,
                            )?.money || 0;
                          return <MaskedValueRenderer value={value} />;
                        },
                      })),
                    {
                      title: t('payroll:total'),
                      dataIndex: 'total',
                      key: 'total',
                      align: 'right',
                      ellipsis: true,
                      width: 100,
                      minWidth: 100,
                      render: function (text: any, record: any, index: any) {
                        const value =
                          record?.dataPayroll?.dataPayroll?.bonus?.reduce(
                            (prev: any, i: any) => (!i?.isTaxed ? prev + i?.money : prev + 0),
                            0,
                          ) || 0;
                        return <MaskedValueRenderer value={value} />;
                      },
                    },
                  ]
                : [],
              render: function (text: any, record: any, index: any) {
                const value =
                  record?.dataPayroll?.dataPayroll?.bonus?.reduce(
                    (prev: any, i: any) => (!i?.isTaxed ? prev + i?.money : prev + 0),
                    0,
                  ) || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
          ],
        };
      }
      if (item.value === 'adjust') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.totalIncomeAdjustment || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'overtime') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          children: [
            ...dataOtRate?.map((item: any) => ({
              title: <HeaderTop>{item}</HeaderTop>,
              dataIndex: item,
              key: item,
              align: 'right',
              ellipsis: true,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.dataPayroll?.overtime?.find(
                  (i: any) => i?.rate === item,
                )?.overtimeHours;
                return value || 0;
              },
            })),
            {
              title: <HeaderTop>{t('payroll:taxable')}</HeaderTop>,
              dataIndex: 'taxable',
              key: 'taxable',
              align: 'right',
              ellipsis: true,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.taxableOvertimePayment || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
            {
              title: <HeaderTop>{t('payroll:non_taxable')}</HeaderTop>,
              dataIndex: 'nonTaxable',
              key: 'nonTaxable',
              align: 'right',
              ellipsis: true,
              width: 100,
              minWidth: 100,
              render: function (text: any, record: any, index: any) {
                const value = record?.dataPayroll?.nonTaxableOvertimePayment || 0;
                return <MaskedValueRenderer value={value} />;
              },
            },
          ],
        };
      }
      if (item.value === 'totalIncomeThisPeriod') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          align: 'right',
          width: 100,
          minWidth: 100,
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.totalIncomeBeforeTax || 0;
            return <StyledSalary>{<MaskedValueRenderer value={value} />}</StyledSalary>;
          },
        };
      }
      if (item.value === 'dependents') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.dataPayroll?.deduction?.totalPersonDependant;
            return value || 0;
          },
        };
      }
      if (item.value === 'pitDeduction') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.totalPITDeduction || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'taxableIncome') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.taxableIncome || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'taxedIncome') {
        return {
          title: <HeaderDown>{item.label}</HeaderDown>,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.taxedIncome || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'pit') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.totalTaxPersonIncome || 0;
            const isPostTermination = record?.dataPayroll?.formulaProfile === 'POST_TERMINATION';
            if (isPostTermination) {
              return (
                <Tooltip
                  title={
                    t('payroll:post_termination_pit_tooltip') ||
                    'Thuế TNCN khấu trừ 10% theo NĐ 253/2026/NĐ-CP (chi trả sau chấm dứt HĐLĐ, không giảm trừ gia cảnh)'
                  }
                >
                  <span style={{ color: '#D97706', fontWeight: 600 }}>
                    <MaskedValueRenderer value={value} />
                  </span>
                </Tooltip>
              );
            }
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'insurance') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value =
              record?.dataPayroll?.dataPayroll?.insuranceIncomeTax?.contribuEmployee || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'advance') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: (text: any, record: any, index: any) => {
            const value = record?.dataPayroll?.totalAdvance || 0;

            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'actual') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 100,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.actualReceiveSalary || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
      if (item.value === 'total') {
        return {
          title: item.label,
          dataIndex: item.value,
          key: item.value,
          width: 130,
          minWidth: 100,
          align: 'right',
          render: function (text: any, record: any, index: any) {
            const value = record?.dataPayroll?.totalSalaryCost || 0;
            return <MaskedValueRenderer value={value} />;
          },
        };
      }
    });
    setColumns([...arr.slice(0, arr.length - 1), ...temp, arr[arr.length - 1]]);
    setWidthTable((width: any) => width + cols.length * 150);
  };

  useEffect(() => {
    if (workflowType) {
      // setColumns(COLUMNS);
      addColumns(addColumnTableHeader);
    }
    if (childRefAddColumn?.current) {
      addColumns(addColumnTableHeader);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    bonusColAdd,
    allowanceColAdd,
    payrollGroupUser,
    workflowType,
    t,
    statusFilterOptions,
    summary,
  ]);

  useEffect(() => {
    setAddColumnTableHeader(colEmployeeTableRoot);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisibleAddColumn]);

  const handleAddColumn = (key: any, parent: any) => {
    switch (parent) {
      case 'allowance': {
        switch (key) {
          case 'grossTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              grossTax: true,
            });
            break;
          case 'grossNoTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              grossNoTax: true,
            });
            break;
          case 'noGrossTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              noGrossTax: true,
            });
            break;
          case 'noGrossNoTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              noGrossNoTax: true,
            });
            break;
          default:
            break;
        }
        break;
      }
      case 'bonus': {
        switch (key) {
          case 'tax':
            setBonusColAdd({
              ...bonusColAdd,
              tax: true,
            });
            break;
          case 'noTax':
            setBonusColAdd({
              ...bonusColAdd,
              noTax: true,
            });
            break;
          default:
            break;
        }
        break;
      }
      default:
        break;
    }
  };

  const handleCloseColumn = (key: any, parent: any) => {
    switch (parent) {
      case 'allowance': {
        switch (key) {
          case 'grossTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              grossTax: false,
            });
            break;
          case 'grossNoTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              grossNoTax: false,
            });
            break;
          case 'noGrossTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              noGrossTax: false,
            });
            break;
          case 'noGrossNoTax':
            setAllowanceColAdd({
              ...allowanceColAdd,
              noGrossNoTax: false,
            });
            break;
          default:
            break;
        }
        break;
      }
      case 'bonus': {
        switch (key) {
          case 'tax':
            setBonusColAdd({
              ...bonusColAdd,
              tax: false,
            });
            break;
          case 'noTax':
            setBonusColAdd({
              ...bonusColAdd,
              noTax: false,
            });
            break;
          default:
            break;
        }
        break;
      }
      default:
        break;
    }
  };

  const IconAddComponents = (
    <CustomIcon type={'add'} component={() => <img src={IconAdd} alt="" />} />
  );

  const handleSearch = (value: string) => {
    if (setSearch) {
      // const temp = payrollGroupUser?.payroll?.filter((item: any) => {
      //   return (
      //     item?.user?.fullName && removeAccents(item?.user?.fullName?.toLowerCase()).includes(text)
      //   );
      // });
      // setData(formatDataIncludeUserIds(temp));
      setSearch(value);
    }
  };

  const handleActionSave = (values: any) => {
    const body: any = {
      payrollDetailsId: Number(id),
      actionId: currentActionId,
      // Modal ModalFormReason đã bắt buộc nhập lý do; không dùng fallback '' để
      // tránh âm thầm gửi note rỗng qua backend (backend cũng đã chặn rỗng/whitespace)
      note: values?.reason?.trim(),
    };
    // Case-by-case: nếu có chọn nhân viên thì chỉ duyệt các NV đó; không chọn -> duyệt cả cụm (như cũ)
    if (selectUserPayRollId?.length) {
      body.userIds = selectUserPayRollId;
    }
    dispatch(
      sendActionPayroll({
        body,
        callBack: () => {
          setRejectModalVisible(false);
          callAPiGetUserGroup();
        },
      }),
    );
  };

  const handleExportExcel = () => {
    const body = {
      userIds: selectUserPayRollId,
    };
    dispatch(exportPayrollDetailExcel({ body, id: +id }));
  };

  // Handler for import CSV
  const handleImportCsv = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    dispatch<any>(
      importPayrollCsv({
        id,
        file,
      }),
    )
      .unwrap()
      .then((res: { data: ImportResult }) => {
        const { data } = res;

        if (data.errorCount > 0) {
          // Set import result data and show modal
          setImportResult(data);
          setResultModalVisible(true);
        } else {
          notification.success({
            message: 'Import thành công',
            description: `Import thành công ${data.successCount} dòng!`,
            duration: 4,
          });
        }
      })
      .catch(() => {
        notification.error({
          message: 'Import dữ liệu thất bại!',
          duration: 4,
        });
      });
    e.target.value = '';
  };

  const handleExportPdf = () => {
    const body = {
      userIds: selectUserPayRollId,
    };
    dispatch(exportPayrollDetailPdf({ body, id: +id }));
  };

  const handleSendMail = async () => {
    const period = filteredData[0]['monthYear'];
    let recipients: any[] = [];
    try {
      const res: any = await payrollApi.getPayslipRecipients({
        userIds: selectUserPayRollId,
        period,
        payrollDetailsId: Number(id),
      });
      recipients = res?.data || [];
    } catch (e) {
      return; // axiosClient interceptor đã toast lỗi
    }
    const sendable = recipients.filter((r) => r.canSend);
    const offboardPersonal = sendable.filter((r) => r.isOffboarded);
    const blocked = recipients.filter((r) => !r.canSend);
    const renderList = (list: any[], withEmail: boolean) => (
      <ul style={{ maxHeight: 160, overflowY: 'auto', paddingLeft: 18, margin: '4px 0 12px' }}>
        {list.map((r) => (
          <li key={r.userId}>
            {r.employeeId} - {r.fullName}
            {withEmail && r.email ? ` (${r.email})` : ''}
          </li>
        ))}
      </ul>
    );

    if (!sendable.length) {
      Modal.warning({
        title: t('payroll:payslip_recipients_title'),
        content: (
          <>
            <p>{t('payroll:payslip_nothing_to_send')}</p>
            {blocked.length > 0 && (
              <>
                <p>{t('payroll:payslip_blocked_no_personal', { count: blocked.length })}</p>
                {renderList(blocked, false)}
              </>
            )}
          </>
        ),
      });
      return;
    }

    Modal.confirm({
      title: t('payroll:payslip_recipients_title'),
      width: 600,
      content: (
        <>
          <p>{t('payroll:payslip_send_count', { count: sendable.length })}</p>
          {offboardPersonal.length > 0 && (
            <>
              <p>{t('payroll:payslip_offboard_personal', { count: offboardPersonal.length })}</p>
              {renderList(offboardPersonal, true)}
            </>
          )}
          {blocked.length > 0 && (
            <>
              <p style={{ color: '#cf1322' }}>
                {t('payroll:payslip_blocked_no_personal', { count: blocked.length })}
              </p>
              {renderList(blocked, false)}
            </>
          )}
        </>
      ),
      okText: t('action:confirm'),
      cancelText: t('action:cancel'),
      onOk: () => {
        const body = {
          userIds: sendable.map((r) => r.userId),
          period,
          payrollDetailsId: Number(id),
        };
        dispatch(sendPayslipManual({ body }));
      },
    });
  };

  const menuExport = (
    <Menu>
      {
        <Menu.Item key="1" onClick={handleExportExcel}>
          Excel
        </Menu.Item>
      }
      {
        <Menu.Item key="2" onClick={handleExportPdf}>
          PDF
        </Menu.Item>
      }
    </Menu>
  );

  // handle onFilter clicked
  const onFilterPopupConfirm = (selectedKeys: any, confirm: any) => {
    // confirm && confirm();
  };

  // filter columns
  function getColumnSearchProps(dataIndex: any, options: any) {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <SearchPopup
          searchText={selectedKeys[0]}
          onPressEnter={() => confirm()}
          options={options}
          confirm={confirm}
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          onSearchTextChange={(e: any) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onClickFilter={(checkedValues: any) => onFilterPopupConfirm(selectedKeys, confirm)}
        />
      ),
      filterIcon: (filtered: any) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value: any, record: any) => {
        return record?.user?.[dataIndex] === value;
      },
    };
  }

  const handleChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: Array<any>[] },
  ) => {
    if (!filters?.departmentName?.length && !filters?.positionName?.length) {
      setIsFilter(false);
    } else {
      setIsFilter(true);
    }
    setFilteredData((extra.currentDataSource as any) || []);

    //call api to sort here
    if (sorter.order) {
      // const array: any = [
      //   {
      //     [sorter.columnKey]: sorter.order === 'ascend' ? 'ASC' : 'DESC',
      //   },
      // ];
      setSort(sorter.order === 'ascend' ? 'ASC' : 'DESC');
      setSortBy(sorter.columnKey);
    } else {
      setSort('');
      setSortBy('');
    }
  };

  const handleSync = () => {
    dispatch(
      syncPayroll({
        body: {
          id,
          userIds: selectUserPayRollId,
          type: 'user',
        },
        callBack: () => {
          callApi && callApi();
        },
      }),
    );
  };

  const payrollRowSelection = {
    selectedRowKeys: selectUserPayRollId,
    onChange: (selectedRowKeys: any[]) => {
      setSelectUserPayRollId(selectedRowKeys?.filter(Boolean) || []);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.disabled || record?.isChildren,
      name: record.disabled || record?.isChildren,
    }),
  };

  return (
    <>
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <SearchContainer>
            <ITVSearch handleSearch={handleSearch} style={{ width: '210px' }} />
          </SearchContainer>
          <div style={{ display: 'flex', gap: 5 }}>
            <CustomButton
              disabled={!selectUserPayRollId?.length}
              onClick={() => {
                handleSync();
                // callApi && callApi()
              }}
            >
              <SyncOutlined />
              Synchronize
            </CustomButton>
            <Popover
              placement="bottom"
              content={
                <AddColumn
                  ref={childRefAddColumn}
                  handleVisibleAddColumn={handleHideAddColumn}
                  addColumns={addColumns}
                  colEmployeeTableRoot={addColumnTableHeader}
                  isHistory={true}
                />
              }
              trigger="click"
              open={isVisibleAddColumn}
              onOpenChange={handleVisibleChange}
            >
              <CustomButton icon={IconAddComponents} aType="text">
                {t('action:add_column')}
              </CustomButton>
            </Popover>
            {anyUserClosed && (
              <Tooltip
                title={
                  !selectUserPayRollId?.length
                    ? t(
                        'payroll:select_employee_to_send_payslip',
                        'Please select employees to send payslips',
                      )
                    : !selectedAllClosed
                    ? t(
                        'payroll:only_closed_can_send_payslip',
                        'Only employees with completed approval (close) can receive payslips',
                      )
                    : ''
                }
              >
                <span>
                  <CustomButton disabled={!selectedAllClosed} onClick={handleSendMail}>
                    <SendOutlined />
                    {t('payroll:send_payslip')}
                  </CustomButton>
                </span>
              </Tooltip>
            )}
            {canOpenPayrollSettings && (
              <CustomButton
                aType="text"
                onClick={() => historyRouter.push('/configuration/payroll?tab=set_up_insurance')}
              >
                <SettingOutlined /> {t('payroll:open_tax_insurance_config')}
              </CustomButton>
            )}
            <CustomButton
              aType="text"
              onClick={() => {
                setCurrentItem(null);
                setMode(MODE.VIEW_HISTORY);
              }}
            >
              <HistoryOutlined />
              {t('payroll:history', 'History')}
            </CustomButton>
            <Dropdown
              overlay={menu}
              disabled={!getActionCurrentUser(workflowType, effectiveStatus, getUser()?.id)?.length}
            >
              <CustomButton aType="outline">
                {t('recruitment:send_for_approval')} <DownOutlined />
              </CustomButton>
            </Dropdown>
            {
              <>
                <CustomButton
                  disabled={
                    !checkPermissionCurrentUser(
                      workflowType,
                      'create',
                      currentWorkflowStatus,
                      getUser()?.id,
                    )
                  }
                  type="primary"
                  onClick={() => {
                    dispatch(setCheckRow([]));
                    setSelectUser([]);
                    setShowModal(true);
                  }}
                  //   disabled={isDisableButton}
                >
                  <PlusOutlined /> {t('payroll:addUser')}
                </CustomButton>
                <Dropdown overlay={menuExport} disabled={!selectUserPayRollId?.length}>
                  <HeaderRemove icon={IconExportComponents}>
                    {t('action:export')} <DownOutlined />
                  </HeaderRemove>
                </Dropdown>
                {/* Button Import Excel */}
                <CustomButton
                  type="default"
                  style={{ marginLeft: 8 }}
                  onClick={() => {
                    document.getElementById('import-excel-input')?.click();
                  }}
                >
                  {t('action:import')} <ImportOutlined />
                </CustomButton>
                <input
                  id="import-excel-input"
                  type="file"
                  accept=".csv"
                  style={{ display: 'none' }}
                  onChange={handleImportCsv}
                />
              </>
            }
            {/* <HeaderRemove
              style={{ marginLeft: 5 }}
              icon={<UploadOutlined />}
{{ ... }}
            >
              {t('action:export')}
            </HeaderRemove> */}
          </div>
        </div>
        <ApprovalProgress
          payrollId={Number(id)}
          refreshKey={`${payrollGroupUser?.payrollDetails?.status || ''}|${Object.values(
            userStatusMap || {},
          ).join(',')}`}
        />
        <PayrollSummaryCards totals={summary?.totals || null} loading={loadingSummary} />
        <ITVTable
          loading={loadingPayrollGroupUser}
          columns={columns}
          data={data}
          filteredData={filteredData}
          onChange={handleChange}
          rowSelection={payrollRowSelection}
          height={550}
          totalResult={payrollGroupUser?.totalResult || undefined}
          setOffset={setCurrentPage}
          offset={currentPage}
          setLimit={setSizePage}
          limit={sizePage}
          rowKey={['user', 'id']}
          isRowSelect={true}
          summary={buildSummaryRow({
            columns,
            baseDataIndexes: COLUMNS.map((c: any) => c.dataIndex),
            summaryRecord: summary?.summaryRecord,
            label: t('payroll:summary_row_label'),
            hasSelection: true,
          })}
        />
        {/* che */}
        {showData && (
          <div
            style={{
              position: 'absolute',
              top: '174px',
              right: '16px',
              width: '6px',
              height: '38px',
              background: '#D6D9E0',
              zIndex: 999,
            }}
          ></div>
        )}

        {mode !== '' && (
          <Modal
            style={{ top: 0 }}
            open={mode !== ''}
            title={
              mode === MODE.VIEW_HISTORY
                ? 'View History'
                : mode === MODE.UPDATE
                ? t('timesheet:View_Detail')
                : t('timesheet:View_Detail')
            }
            okText={'OK'}
            cancelText={'Cancel'}
            width={mode === MODE.VIEW_HISTORY ? '80%' : 1050}
            maskClosable={false}
            onCancel={() => {
              setMode('');
              setCurrentItem(null);
            }}
            footer={null}
            centered
          >
            {mode === MODE.UPDATE ? (
              <ViewEdit
                status={currentWorkflowStatus}
                workflow={workflowType}
                currentItem={currentItem}
                callBack={callAPiGetUserGroup}
              />
            ) : mode === MODE.VIEW_HISTORY ? (
              <HistoryRequest id={id} userList={data} />
            ) : (
              <ViewPayslip record={currentItem} />
            )}
          </Modal>
        )}
        <Modal
          open={showModal}
          style={{ top: 0 }}
          title={t('overtime:add_member')}
          okText={'Apply'}
          cancelButtonProps={{ style: { display: 'none' } }}
          width={800}
          maskClosable={false}
          onCancel={() => {
            setShowModal(false);
            setSelectUser([]);
          }}
          okButtonProps={{ disabled: !selectUser || selectUser?.length === 0 }}
          onOk={() => {
            const currentData = data?.map(({ user }: any) => user?.id);
            const body = {
              userIds: [...selectUser, ...currentData],
              type: TypeEditPayroll.USER,
            };
            dispatch(
              updatePayroll({
                id,
                actionType: 'update',
                body,
                callBack: () => {
                  callAPiGetUserGroup();
                  setShowModal(false);
                  setSelectUser([]);
                },
              }),
            );
          }}
          destroyOnClose
        >
          <ViewAddMember dataOrigin={data} setSelectUser={setSelectUser} id={id} />
        </Modal>
        <ModalFormReason
          title={'Note'}
          isModalReason={rejectModalVisible}
          setIsModalReason={setRejectModalVisible}
          handleFinish={handleActionSave}
          requiredReason={currentActionIsReject}
        />
        {/* Result Modal */}
        <ImportPayrollResultModal
          visible={resultModalVisible}
          onClose={() => setResultModalVisible(false)}
          data={importResult}
        />
      </Container>
    </>
  );
};

export default ManageRequestTab;
export const SearchContainer = styled.div`
  width: 200px;
  margin-bottom: 20px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: white;
  width: 100%;
  height: max-content;
  .summary-last-column {
    right: 6px;
  }
  position: relative;
`;
export const Cell = styled(Table.Summary.Cell)`
  text-align: right;
  .ant-table-cell {
    background: red !important;
    width: 100% !important;
    text-align: right;
  }
`;
export const CustomIcon = styled(Icon)`
  ${(props) =>
    props.type === 'search' &&
    css`
      img {
        height: 15px;
        width: 15px;
      }
    `}
  ${(props) =>
    props.type === 'add' &&
    css`
      img {
        padding-bottom: 6px;
        height: 15px;
        width: 15px;
      }
    `}
  ${(props) =>
    props.type === 'export' &&
    css`
      img {
        padding-bottom: 6px;
        height: 20px;
        width: 16px;
      }
    `}
`;

const StyledSalary = styled.div`
  color: var(--cl_success500);
`;
